module.exports = __webpack_public_path__ + "media/core_static/throbber-f3bc1490.gif";